<template>
  <div class="container flex" style="margin-bottom: 20px;">
     <left></left>
     <div class="live flex1" style="margin-left: 20px;">
     	<div class="title">
     		考试结果
     	</div>
     	<div class="bg padding-15">
     		<div class="gray" style="padding-bottom: 50px;">
     			<div class="titles font18" style="font-weight: bold;">
     				{{title}}
     			</div>
     			<div class="smallTitle margin-t-10">
     				{{title}}
     			</div>
     			<div class="text-center">
     				<div class="circle" style="margin-top: 70px;">
     					<div class="" style="font-size: 36px;margin-top: 10px;font-weight: bold;">
     						{{myScore}}
     					</div>
     					<div class="font14" style="color: #999;">
     						总分{{totalScore}}
     					</div>
     					<div class="" style="color: #5cb85c;margin-top: 10px;font-weight: bold;">
     						{{resultstring}}
     					</div>
     				</div>
     			</div>
     			<div class="flex algin-center margin-t-15" style="justify-content: center;margin-top: 30px;">
     				<div class="item">
     					<div class="font12" style="color: #999;">
     						答题用时
     					</div>
     					<div class="font18">
     						{{time}}分钟
     					</div>
     				</div>
     				<div class="line">

     				</div>
     				<div class="item">
     					<div class="font12" style="color: #999;">
     						平时用时
     					</div>
     					<div class="font18">
     						{{(time/count).toFixed(1)}}分钟
     					</div>
     				</div>
     				<div class="line">

     				</div>
     				<div class="item">
     					<div class="font12" style="color: #999;">
     						平时得分
     					</div>
     					<div class="font18">
     						{{(myScore/count).toFixed(2)}}
     					</div>
     				</div>
     				<div class="line">

     				</div>
     				<div class="item">
     					<div class="font12" style="color: #999;">
     						未作答
     					</div>
     					<div class="font18">
     						{{undoCount}}
     					</div>
     				</div>
     				<div class="line">

     				</div>
     			</div>
     			<div class="btnwrap" @click="Analysis">
     				<span class="btn" style="cursor: pointer;">查看解析</span>
     			</div>
     		</div>


     	</div>
     </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          totalScore:this.$route.query.totalScore,
          myScore:this.$route.query.myScore,
          undoCount:this.$route.query.undoCount,
          title:this.$route.query.title,
          count:this.$route.query.count,
          time:this.$route.query.time,
          resultstring:this.$route.query.myScore/this.$route.query.totalScore>0.6?'及格':'不及格'
      }
    },
    methods:{
      Analysis(){
        this.$router.push('viewAnswer')
      }
    },
    created(){

    }
  }
</script>

<style scoped="">
  .gray {
  	background-color: #f0f7ff;
  	text-align: center;
  	padding: 30px 0;
  }
  .btn {
  	width: 200px;
  	height: 44px;
  	line-height: 44px;
  	color: #FFFFFF;
  	background-color: #4fa7ff;
  	display: inline-block;
  	margin-top: 60px;
  }

  .circle{
  	border: 3px solid #4fa7ff;
  	width: 120px;
  	height: 120px;
  	display: inline-block;
  	border-radius: 50%;

  }
  .line  {
  	height: 50px;
  	width: 1px;
  	background-color: #ccc;
  	margin: 0 30px;
  	opacity: .4;
  }
</style>



// WEBPACK FOOTER //
// src/components/examsresult.vue